import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Subject, takeUntil} from 'rxjs';
import {RecipeService} from '../../../services/recipe/recipe.service';
import {QueryModel} from '../../../services/http/http.service';
import {MatOption, MatSelect} from '@angular/material/select';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {ValueService} from '../../../services/value/value.service';
import {PrescriptionFormatInterface} from '../../../models/values/prescription-format/prescription-format.interface';
import {iResponse, iResponseList} from '../../../models/response/response.model';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
    selector: 'app-prescription-preview',
    imports: [
        MatSelect,
        ReactiveFormsModule,
        MatOption
    ],
    templateUrl: './prescription-preview.component.html',
    styleUrl: './prescription-preview.component.sass'
})
export class PrescriptionPreviewComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>()
    prescriptionId: string = ''
    isPublished: boolean = false
    prescriptionTypeControl = new FormControl(0)
    prescriptionTypeList: PrescriptionFormatInterface[] = []
    prescriptionPreviewBase64String: string = ''
    pdfUrl: SafeResourceUrl = ''
    buttonActive: boolean = true;

    constructor(
        public dialogRef: MatDialogRef<PrescriptionPreviewComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { prescriptionId: string, published: boolean },
        private recipeService: RecipeService,
        private valueService: ValueService,
        private sanitizer: DomSanitizer
    ) {

    }

    ngOnInit(): void {
        this.getPrescriptionFormats();
        if (this.data.prescriptionId) {
            this.prescriptionId = this.data.prescriptionId
            const query = {
                format: 0
            }
            this.previewPrescription(this.prescriptionId, query)
        }
        if (this.data.published) {
            this.isPublished = this.data.published
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onClose(): void {
        this.dialogRef.close();
    }

    onSubmit(): void {
        if (this.isPublished) {
            this.downloadPrescription();
        } else {
            this.savePrescription();
        }
    }

    changePreviewType(): void {
        const query = {
            format: this.prescriptionTypeControl.value
        }
        this.previewPrescription(this.prescriptionId, query)
    }

    private previewPrescription(prescriptionId: string, query: QueryModel): void {
        this.recipeService.previewPrescription(prescriptionId, query)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponse<any>) => {
                    this.prescriptionPreviewBase64String = response.data
                    this.pdfUrl = this.getSafePdfUrl(this.prescriptionPreviewBase64String);
                },
                error: (error) => {
                }
            })
    }

    private getPrescriptionFormats(): void {
        this.valueService.getPrescriptionFormats()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponseList<PrescriptionFormatInterface>) => {
                    this.prescriptionTypeList = response.data
                },
                error: (error) => {
                }
            })
    }

    private savePrescription(): void {
        this.buttonActive = false;
        this.recipeService.saveRecipe(this.prescriptionId)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    this.buttonActive = true;
                    this.downloadPrescription();
                },
                error: (error) => {
                }
            })
    }

    downloadPrescription(): void {
        const query: QueryModel = {
            format: this.prescriptionTypeControl.value
        }
        this.recipeService.downloadPrescription(this.prescriptionId, query)

        setTimeout(() => {
            this.dialogRef.close();
        }, 400);
    }

    getSafePdfUrl(base64String: string): SafeResourceUrl {
        return this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + base64String);
    }
}
